import { ReactComponent as autoStoriesIcon } from '../../../../../icons/auto_stories.svg';
import React, { useContext, useState } from "react";
import Modal from "../../../../../components/modalWindow/modal";
import ButtonField from '../../../../../components/buttonField/buttonField';
import { classNameBtn, iconPosition } from '../../../../../components/shared/button/types/buttonProps';
import { ButtonFieldProps } from '../../../../../components/buttonField/types/buttonFieldProps';
import { stylizationVerticalAlign } from '../../../../../components/shared/stylization';
import { apiContext } from '../../../../../contexts/apiContext';
import { notifyError, notifySuccess } from '../../../../../components/snackbar/snackbar';
import { FormFieldProps } from '../../../../../components/formField/types/formFieldProps';
import FormField from '../../../../../components/formField/formField';
import PoFormContext, { InstitutionsAttributes } from '../../../../../contexts/poFormContext';
import { InstitutionsAddModalProps } from './types/institutionsAddModalProps';
import { AddInstitutionDictProposalProps } from '../../../../../services/dictionariesService/types/dictionariesServiceProps';
import { addInstitutionDictProposal } from '../../../../../services/dictionariesService/dictionariesService';
import { createConfigValidation } from "../../../../../helpers/validation/validation";
import AuthContext from '../../../../../contexts/authContext';
import KrFormContext from '../../../../../contexts/krFormContext';
import { setDictProposition } from '../../../../../database/indexedDbReadWrite';

const InstitutionsAddModal = (props: InstitutionsAddModalProps) => {
    const api = useContext(apiContext);
    const [newInstitution, setNewInstitution] = useState<InstitutionsAttributes>({});
    const [checkValidationFlag, setCheckValidationFlag] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const { username, onlineMode } = useContext(AuthContext);
    const { local } = useContext(KrFormContext);
    const { localPo } = useContext(PoFormContext);

    // Inputs
    const getInputProps = (labelName: string, inputPlaceholder: string, inputId: string, value?: string): FormFieldProps => {
        return {
            labelName: labelName,
            inputPlaceholder: inputPlaceholder,
            type: "text",
            pristine: true,
            value: value,
            className: "empty",
            setValue: (event: any) => onChangeInputNewInstitution(event, inputId),
            configValidation: createConfigValidation("onlyRequired"),
            validationError: checkValidationFlag,
            disabled: loading
        };
    }

    const onChangeInputNewInstitution = (event: any, id: any) => {
        setNewInstitution((prevData) => ({ ...prevData, [id]: event }));
    }

    // Add institution proposal button
    const getBtnProps = (title: string, className: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${classNameBtn.Btn} ${className} body-txt-medium`
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            iconPosition: iconPosition.Start
        };
    }

    const checkValidation = () => {
        setCheckValidationFlag(true);

        if (newInstitution.nazwa === undefined || newInstitution.nazwa === null) return false;
        if (newInstitution.ulica === undefined || newInstitution.ulica === null) return false;
        if (newInstitution.nr === undefined || newInstitution.nr === null) return false;
        if (newInstitution.miejscowosc === undefined || newInstitution.miejscowosc === null) return false;
        if (newInstitution.kod === undefined || newInstitution.kod === null) return false;
        return true;
    }

    const addInstitutionProposal = () => {
        if (checkValidation()) {
            let addInstitutionDictProposalProps: AddInstitutionDictProposalProps = {
                selectedAuthorId: props.selectedAuthorId,
                newInstitution: newInstitution,
                isSingleInstitution: props.isSingleInstitution,
                apiBase: api.apiUrl + api.apiVersion
            }

            setLoading(true);
            if ((local || localPo) && !onlineMode) {
                setDictProposition(username, addInstitutionDictProposalProps, "institution").then((response) => {
                    notifySuccess({ message: "Dodano propozycję instytucji, propozycja zostanie zsynchronizowana po przejściu na tryb online" });
                    props.cleanSelects();
                    close();
                }).catch(() => {
                    notifyError({ message: "Dodanie propozycji instytucji zakończone niepowodzeniem" });
                }).finally(() => {
                    setLoading(false);
                });
            } else {
                addInstitutionDictProposal(addInstitutionDictProposalProps)
                    .then(() => {
                        notifySuccess({ message: "Dodano propozycję instytucji" });
                        props.cleanSelects();
                        close();
                    })
                    .catch(() => {
                        notifyError({ message: "Dodanie propozycji instytucji zakończone niepowodzeniem" });
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        }
    }

    const close = () => {
        props.onClose();
        refocus();
    }

    const refocus = () => {
        if (props.refocus) props.refocus();
    }

    const actionBtns = [
        <ButtonField key={1} {...getBtnProps("Anuluj", classNameBtn.LargeSecondary, () => { close() })}></ButtonField>,
        <ButtonField key={2} {...getBtnProps("Wyślij propozycję instytucji", classNameBtn.Large, () => { addInstitutionProposal() })}></ButtonField>
    ]

    return (<Modal
        title={"Dodaj instytucję"}
        titleIcon={autoStoriesIcon}
        iconClass='titleIcon'
        width={'500px'}
        height={'510px'}
        onClose={close}
        actionBtns={actionBtns}
        loading={loading}>
        <FormField {...getInputProps("Nazwa", "Wpisz nazwę Instytucji", "nazwa", newInstitution.nazwa)} />
        <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <FormField {...getInputProps("Ulica", "Wpisz nazwę ulicy", "ulica", newInstitution.ulica)} />
            <FormField {...getInputProps("Numer", "Wpisz numer", "nr", newInstitution.nr)} />
        </div>
        <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <FormField {...getInputProps("Miejscowość", "Wpisz miejscowość", "miejscowosc", newInstitution.miejscowosc)} />
            <FormField {...getInputProps("Kod pocztowy", "Wpisz kod pocztowy", "kod", newInstitution.kod)} />
        </div>
    </Modal>);
};

export default InstitutionsAddModal;